import { useState, useEffect } from "react";
import { useNotifications } from "../contexts/NotificationContext";

type KonamiCode = string[];
const KONAMI_CODE = [
	"ArrowUp",
	"ArrowUp",
	"ArrowDown",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight",
	"ArrowLeft",
	"ArrowRight",
	"b",
	"a",
];

export const useEasterEggs = () => {
	const { addNotification } = useNotifications();
	const [ultraMode, setUltraMode] = useState(false);
	const [konamiProgress, setKonamiProgress] = useState<KonamiCode>([]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			const key = event.key;
			const newProgress = [...konamiProgress, key];

			// Verifica se a sequência está correta até agora
			if (
				KONAMI_CODE.slice(0, newProgress.length).every((k, i) => k === newProgress[i])
			) {
				setKonamiProgress(newProgress);

				// Konami Code completo
				if (newProgress.length === KONAMI_CODE.length) {
					setUltraMode(true);
					setKonamiProgress([]);
					// Play ultra mode sound
					new Audio("/sounds/ultra-power.mp3").play().catch(() => {});
					addNotification({
						message: "ULTRA MODE ACTIVATED! 🔥",
						type: "success",
						icon: "⚡",
					});
				}
			} else {
				setKonamiProgress([]);
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [konamiProgress, addNotification]);

	return {
		ultraMode,
		konamiProgress: konamiProgress.length,
	};
};
